<template lang="pug">
  .verify-campaign-category(v-loading="loading")
    ProcurementFinalScope(
      :brief="brief"
      :scope="scope"
    )

    TitleBar {{ $t('采购部确认活动类别') }}
    div(style="margin-left: 20px")
      SelectCampaignCategory(
        v-if="!isView"
        v-model="currentSelectedCategories"
      )
      Category(
        v-else
        :data="category"
      )
      el-row(v-if="!isView")
        el-col(
          :span="20"
          :offset="4"
        )
          footer-button(
            @confirm="submit"
            @cancel="$router.go(-1)"
          )
    SendEmailDialog(
      :visible="visible"
      :email="email"
      @cancel="visible = false"
      @confirm=" () => confirm('SendEmailDialog')"
    )
</template>

<script>
import ProcurementFinalScope from '@/components/ProcurementFinalScope'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import SelectCampaignCategory from '@/components/SelectCampaignCategory'
import Category from '@/components/Category'
import SendEmailDialog from '@/components/SendEmailDialog'
import axios from 'axios'
import { format4backend, validateSelectedCategory } from '@/umcc/util'
import {get} from 'lodash'

const fetchBriefInfo = (campaignID) => {
  return axios.get('/management/campaign/getBriefInfo', {
    params: {
      campaign_id: campaignID
    }
  })
}

const confirmCampaignScope = (params) => {
  return axios.post('/management/final/confirmCampaignScope', format4backend(params))
}

const fetchMarketRecommend = (campaignID, isFinalScope) => {
  return axios.get('/management/campaign/getMarketRecommend', {
    params: {
      campaign_id: campaignID,
      is_final_scope: isFinalScope
    }
  })
}

const fetchContact = campaignID => {
  return axios.get('/management/subfinal/getContactInfo', {
    params: {
      campaign_id: campaignID
    }
  })
}

export default {
  components: {
    ProcurementFinalScope,
    TitleBar,
    SelectCampaignCategory,
    FooterButton,
    SendEmailDialog,
    Category
  },
  data () {
    return {
      visible: false,
      brief: {},
      scope: [],
      currentSelectedCategories: [],
      category: [],
      contact: {},
      loading: false
    }
  },
  computed: {
    campaignID () {
      return this.$store.state.campaign.id
    },
    campaign () {
      return this.$store.state.campaign
    },
    categoryHaveIT () {
      // IT category_id 5
      return this.currentSelectedCategories.find(o => o.category_id === '5')
    },
    email () {
      return this.categoryHaveIT
        ? get(this.contact['it'], 'mail', null)
        : this.$store.state.common.user.mail
    },
    taskName () {
      return this.$store.state.campaign.taskName
    }
  },
  mounted () {
    if (this.isView) {
      this.fetchViewData()
    }
    this.fetchData()
  },
  methods: {
    async fetchViewData () {
      const res = await axios.get('/common/getBusinessLog', {
        params: {
          servlet_path: this.$route.path,
          business_key: this.campaignID // 项目id或SubFinalScopeId
        }
      })

      this.category = res.campaign_category
    },
    async fetchData () {
      const [res1, res2, contact] = await Promise.all([
        fetchBriefInfo(this.campaignID),
        fetchMarketRecommend(this.campaignID, this.campaign.isNewBrief),
        fetchContact(this.campaignID)
      ])

      this.brief = res1
      this.scope = res2.selected_scope
      this.contact = contact
    },
    async submit () {
      if (this.currentSelectedCategories.length === 0) {
        this.$message.error(this.$t('请选择项目类别'))
        return
      }

      if (!validateSelectedCategory(this.currentSelectedCategories)) {
        this.$message.error(this.$t('每个项目类别下至少需要选择一个业务范围'))
        return
      }

      const params = {
        campaign_id: this.campaignID,
        campaign_category: this.currentSelectedCategories,
        servlet_path: this.$route.path,
        task_name: this.taskName
      }
      this.loading = true
      this.visible = false
      try {
        await confirmCampaignScope(params)
        this.loading = false
        this.$message.success(this.$t('提交成功'))
      } catch (err) {
        throw new Error(err)
      } finally {
        this.$router.go(-1)
      }
    },
    confirm (type) {
      if (type === 'FooterButton' && this.categoryHaveIT) {
        this.visible = true
        return
      }
      this.submit()
    }
  }
}
</script>
